import React from "react";
import { Sparkles } from "lucide-react";

export default function Logo({ size = "md", loyalty = false }) {
  const dims = size === "lg" ? { w: 44, h: 44, text: "text-2xl" } : { w: 34, h: 34, text: "text-lg" };
  return (
    <div className="flex items-center gap-2" data-testid="brand-logo">
      <div className="relative" style={{ width: dims.w, height: dims.h }}>
        <svg viewBox="0 0 48 48" width={dims.w} height={dims.h} aria-hidden>
          <rect x="4" y="10" width="40" height="28" rx="6" fill="#93c5fd" />
          <path d="M4 16 L24 30 L44 16 L44 12 A2 2 0 0 0 42 10 L6 10 A2 2 0 0 0 4 12 Z" fill="#2563eb" />
        </svg>
        <Sparkles className="absolute -top-1 -right-1 w-4 h-4 text-amber-400 fill-amber-300" />
        <Sparkles className="absolute -top-2 right-2 w-2.5 h-2.5 text-amber-300" />
      </div>
      <div className={`${dims.text} font-extrabold tracking-tight`} style={{ fontFamily: "Outfit, Inter, sans-serif" }}>
        <span className="text-slate-900">Brief</span>
        <span className="text-blue-600">Assist</span>
      </div>
      {loyalty && (
        <span
          data-testid="loyalty-badge"
          title="Treuerabatt aktiv – 10% dauerhaft"
          aria-label="Treuerabatt aktiv"
          className="relative inline-flex items-center gap-1 pl-1.5 pr-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider bg-gradient-to-r from-amber-300 via-amber-400 to-amber-500 text-amber-900 shadow-sm ring-1 ring-amber-500/40"
        >
          <Sparkles className="w-3 h-3 fill-amber-100 stroke-amber-800" />
          Treu
          <span className="absolute -top-1 -right-1 w-2 h-2 rounded-full bg-amber-300 animate-ping" />
        </span>
      )}
    </div>
  );
}
